"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Legal = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _index2 = require("../Text/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Legal = exports.Legal = (0, _styledComponents["default"])(_index2.Text).attrs({
  variant: 'marginal'
}).withConfig({
  displayName: "Legal",
  componentId: "sc-5ufqr3-0"
})(["background:", ";border-radius:", ";color:", ";display:", ";max-width:100%;padding:", ";@media (max-width:", "){display:block;}a{margin-inline-start:0;}"], function (props) {
  return "var(--background-tinted-base, ".concat(_index.defaultTheme[props.$colorSet].background.tinted.base, ")");
}, (0, _index.cssBorderRadius)('base', '4px'), function (props) {
  return "var(--text-subdued, ".concat(_index.defaultTheme[props.$colorSet].text.subdued, ")");
}, function (props) {
  return props.$legalStrict ? 'block' : 'inline-block';
}, (0, _index.cssSpacing)('tighter-2', '8px'), _encoreFoundation.screenXsMax);